<!-- [ Sidebar Menu ] start -->
<nav>
  <div class="navbar-wrapper">
    <div class="m-header">
      <!-- [ Header Topbar ] start -->
      <a [routerLink]="['/default/']" class="b-brand">
        <!-- ========   change your logo hear   ============ -->
        <img width="180px" src="assets/images/DO-h-logo.webp" class="logo logo-lg" />
      </a>
    </div>
    <app-nav-content
      [navCollapsed]="navCollapsed"
      (NavCollapsedMob)="navCollapseMob()"
      (NavCollapse)="NavCollapse.emit()"
      class="scroll-div w-100"
    ></app-nav-content>
  </div>
</nav>
<!-- [ Sidebar Menu ] end -->
